/* eslint-disable import/prefer-default-export */
import { IUser } from 'interfaces/user';

export const getUserData = (users: IUser[], data: string, message: string) => {
  if (users && users.length > 0) {
    return users[0][data] !== '' ? users[0][data] : message;
  }
  return message;
};
